import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { Tooltip } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ActivityRecordingContext } from '../ActivityRecordingProvider';


const PREFIX = 'AddHighlightMarker';

const classes = {
    root: `${PREFIX}-root`
};

const StyledTooltip = styled(Tooltip)(() => ({
    visibility: 'hidden',
    opacity: 0,
    transition: 'opacity 300ms',
    position: 'absolute',
    top: 0,
    marginLeft: -15 + -7, // Offsets: 16px for centering, 7px for container padding
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    '& svg': {
        height: 20
    },
    padding: '6px 4px',
    backgroundColor: '#6BB75A',
    borderRadius: 32,
    color: 'white',
    zIndex: 999,
    '& .AddHighlightMarker-Arrow': {
        position: 'absolute',
        bottom: -3,
        left: '50%',
        marginLeft: -4,
        width: 0,
        height: 0,
        borderLeft: '4px solid transparent',
        borderRight: '4px solid transparent',
        borderTop: '4px solid #6BB75A'
    }
}));

const AddHighlightMarker = (props) => {
    const { t } = useTranslation();

    const { videoPlaybackProgress, videoDuration } = useContext(ActivityRecordingContext);
    const start = (1 / videoDuration) * videoPlaybackProgress.playedSeconds;

    return (
        <StyledTooltip title={t('sessionHighlights.buttons.createHighlight')}>
            <div
                className={`${classes.root} VL-AddHighlightMarker`}
                onClick={props.onClick}
                key={'VL-EventsTimeline-Add-Highlight-Marker'}
                style={{
                    left: `${start * 100}%`
                }}
            >
                <AddIcon />

                <div className="AddHighlightMarker-Arrow" />
            </div>
        </StyledTooltip>
    );
};

AddHighlightMarker.propTypes = {
    onClick: PropTypes.func
};

export default AddHighlightMarker;
